var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "short_answer" }, [
    !_vm.data.answered
      ? _c("div", [
          _c("div", { staticClass: "question" }, [
            _c("div", { staticClass: "title" }, [
              _c("strong", { staticClass: "bold" }, [
                (_vm.data.rule
                ? _vm.data.rule.isNecessary
                  ? 1
                  : 0
                : 0)
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                _vm._v(_vm._s(_vm.data.questionTitle))
              ]),
              _vm._v(" "),
              _vm.data.questionType == 8
                ? _c("span", { staticClass: "span" }, [
                    _vm._v(
                      "（每个同学都有1次提交分享机会，提交后还可看到他人的分享~）"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.questionType == 10 &&
              (_vm.data.rule ? _vm.data.rule.subTitle : false)
                ? _c("span", { staticClass: "span" }, [
                    _vm._v(_vm._s(_vm.data.rule.subTitle))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.data.questionDes
              ? _c(
                  "div",
                  _vm._l(JSON.parse(_vm.data.questionDes), function(o) {
                    return _c("div", {
                      key: JSON.stringify(o),
                      staticClass: "text",
                      domProps: { textContent: _vm._s(o.txt) }
                    })
                  }),
                  0
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "answer" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: _vm.data.questionType == 8 ? 6 : 4,
                  maxlength: _vm.data.rule ? _vm.data.rule.length : 999999,
                  placeholder: _vm.data.rule
                    ? _vm.data.rule.placeholder
                      ? _vm.data.rule.placeholder
                      : "请输入内容"
                    : "请输入内容"
                },
                model: {
                  value: _vm.textarea,
                  callback: function($$v) {
                    _vm.textarea = $$v
                  },
                  expression: "textarea"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "answer_footer clear" }, [
                _vm.data.questionType == 8
                  ? _c(
                      "div",
                      { staticClass: "isPublic fl" },
                      [
                        _c("el-checkbox", {
                          model: {
                            value: _vm.isPublic,
                            callback: function($$v) {
                              _vm.isPublic = $$v
                            },
                            expression: "isPublic"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "txt" }, [
                          _vm._v("公开给所有同学可见")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                (_vm.data.rule
                ? _vm.data.rule.length
                : false)
                  ? _c("div", { staticClass: "num fr" }, [
                      _vm._v(
                        _vm._s(_vm.textarea.length) +
                          " / " +
                          _vm._s(_vm.data.rule.length)
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ])
      : _c("div", [
          _c("div", { staticClass: "question" }, [
            _c("div", { staticClass: "title" }, [
              _c("strong", { staticClass: "bold" }, [
                (_vm.data.rule
                ? _vm.data.rule.isNecessary
                  ? 1
                  : 0
                : 0)
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                _vm._v(_vm._s(_vm.data.questionTitle))
              ]),
              _vm._v(" "),
              _vm.data.questionType == 8
                ? _c("span", { staticClass: "span" }, [
                    _vm._v(
                      "（每个同学都有1次提交分享机会，提交后还可看到他人的分享~）"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.questionType == 10 &&
              (_vm.data.rule ? _vm.data.rule.subTitle : false)
                ? _c("span", { staticClass: "span" }, [
                    _vm._v(_vm._s(_vm.data.rule.subTitle))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.data.questionDes
              ? _c(
                  "div",
                  _vm._l(JSON.parse(_vm.data.questionDes), function(o) {
                    return _c("div", {
                      key: JSON.stringify(o),
                      staticClass: "text",
                      domProps: { textContent: _vm._s(o.txt) }
                    })
                  }),
                  0
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "answer" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: _vm.data.questionType == 8 ? 6 : 4,
                  placeholder: _vm.data.rule
                    ? _vm.data.rule.placeholder
                      ? _vm.data.rule.placeholder
                      : "请输入内容"
                    : "请输入内容",
                  disabled: _vm.disabledBol
                },
                model: {
                  value: _vm.textarea,
                  callback: function($$v) {
                    _vm.textarea = $$v
                  },
                  expression: "textarea"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "answer_footer clear" }, [
                _vm.data.questionType == 8
                  ? _c(
                      "div",
                      { staticClass: "isPublic fl" },
                      [
                        _c("el-checkbox", {
                          model: {
                            value: _vm.isPublic,
                            callback: function($$v) {
                              _vm.isPublic = $$v
                            },
                            expression: "isPublic"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "txt" }, [
                          _vm._v("公开给所有同学可见")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                (_vm.data.rule
                ? _vm.data.rule.length
                : false)
                  ? _c("div", { staticClass: "num fr" }, [
                      _vm._v(
                        _vm._s(_vm.textarea.length) +
                          " / " +
                          _vm._s(_vm.data.rule.length)
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.otherBol
            ? _c("div", { staticClass: "list_header bold" }, [
                _vm._v(
                  "\n      全部回答 （" + _vm._s(_vm.totalCount) + "）\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.otherBol
            ? _c(
                "div",
                { staticClass: "list" },
                [
                  _vm._l(_vm.otherList, function(item, index) {
                    return _c("dynamic-item", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index < 5,
                          expression: "index < 5"
                        }
                      ],
                      key: item.examQuestionId,
                      attrs: {
                        hasMargin: false,
                        time: item.answerTime,
                        imgUrl: item.icon,
                        menber: item.title,
                        content: item.answer
                      }
                    })
                  }),
                  _vm._v(" "),
                  _vm.totalCount > 5
                    ? _c(
                        "div",
                        {
                          staticClass: "look cursor",
                          on: { click: _vm.lookFn }
                        },
                        [_vm._v("\n        查看全部\n      ")]
                      )
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "answerObj none" }, [
      _vm._v(_vm._s(_vm.answerObj))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "isNecessary none" }, [
      _vm._v(_vm._s(_vm.data.rule ? (_vm.data.rule.isNecessary ? 1 : 0) : 0))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-c8d8173c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c8d8173c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/topic/public/short-answer.vue
// module id = null
// module chunks = 